import { createFeatureSelector, createSelector } from '@ngrx/store'
import { favouriteItemsAdapter, FavouriteItemsState, FAVOURITE_ITEMS_FEATURE_KEY } from './favourite-items.reducer'

// Lookup the 'FavouriteItems' feature state managed by NgRx
export const getFavouriteItemsState = createFeatureSelector<FavouriteItemsState>(FAVOURITE_ITEMS_FEATURE_KEY)

const { selectAll, selectIds } = favouriteItemsAdapter.getSelectors()

export const getFavouriteItemsLoaded = createSelector(
  getFavouriteItemsState,
  (state: FavouriteItemsState) => state.loaded,
)

export const getAllFavouriteItems = createSelector(getFavouriteItemsState, (state: FavouriteItemsState) =>
  selectAll(state),
)

export const getAllFavouriteItemIds = createSelector(getFavouriteItemsState, (state: FavouriteItemsState) =>
  selectIds(state),
)

export const getFavouriteItemsCount = createSelector(getFavouriteItemsState, (state) => state.count)

export const getFavouriteItemsOrder = createSelector(getFavouriteItemsState, (state) => state.order)

export const getFavouriteItemsStalePages = createSelector(getFavouriteItemsState, (state) => state.stale)

export const getEnableFavourite = createSelector(
  getFavouriteItemsState,
  (state: FavouriteItemsState) => state.enableFavourite,
)
